<template>
  <div class="home-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>{{ $t("home.heroTitle") }}</h1>
        <p>{{ $t("home.heroSubtitle") }}</p>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="main-content">
      <div class="home-container">
        <!-- 左侧联系信息 -->
        <div class="contact-info">
          <h3 class="contact-title">{{ $t("home.directorContact") }}</h3>
          <template v-if="directorLoading || directorError || !director">
            <div class="contact-item" v-for="n in 5" :key="'dc-' + n">
              <span class="skeleton-title" style="width:100%;height:14px;display:block;margin-bottom:10px;"></span>
            </div>
          </template>
          <template v-else>
            <div class="contact-item">
              <span class="contact-label">{{ $t("home.name") }}</span>
              <span>{{ director.name }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("home.title") }}</span>
              <span>{{ director.title }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("home.email") }}</span>
              <span>{{ director.email }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("home.office") }}</span>
              <span>{{ director.office }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("home.officeHours") }}</span>
              <span>{{ director.officeHours }}</span>
            </div>
          </template>
        </div>

        <!-- 右侧通知/新闻 -->
        <div class="right-content">
          <div class="info-box">
            <h3 class="box-title">{{ $t("home.notices") }}</h3>
            <div class="info-list">
              <template v-if="noticeLoading">
                <div class="skeleton-item" v-for="n in 3" :key="'s1-' + n">
                  <span class="skeleton-date"></span>
                  <span class="skeleton-title"></span>
                </div>
              </template>
              <template v-else>
                <div class="info-item" v-for="item in notices" :key="item.id">
                  <span class="info-date">{{ item.date }}</span>
                  <span
                    class="info-title clickable"
                    @click="goToDetail(item)"
                    >{{ item.title }}</span
                  >
                </div>
              </template>
            </div>
          </div>

          <div class="info-box">
            <h3 class="box-title">{{ $t("home.dailyRecommend") }}</h3>
            <div class="info-list">
              <template v-if="newsLoading">
                <div class="skeleton-item" v-for="n in 3" :key="'s2-' + n">
                  <span class="skeleton-date"></span>
                  <span class="skeleton-title"></span>
                </div>
              </template>
              <template v-else>
                <div class="info-item" v-for="item in news" :key="item.id">
                  <span class="info-date">{{ item.date }}</span>
                  <span
                    class="info-title clickable"
                    @click="goToDetail(item)"
                    >{{ item.title }}</span
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";
import { listInform, listNews, getDirectorContact } from "../../api/home";

export default {
  name: "HomePage",
  components: { Header, Nav, Footer },
  data() {
    return {
      notices: [],
      news: [],
      noticeLoading: true,
      newsLoading: true,
      director: null,
      directorRaw: null,
      directorLoading: true,
      directorError: false,
    };
  },
  methods: {
    setDefaultLogo(event) {
      event.target.src = defaultLogo;
    },
    async getInformList() {
      this.noticeLoading = true;
      let res = await listInform();
      if (res.code === 0) {
        this.notices = res.rows.map((item) => ({
          id: item.noticeId,
          date: item.createTime,
          title: item.noticeTitle,
        }));
      }
      this.noticeLoading = false;
    },
    async getNewsList() {
      this.newsLoading = true;
      let res = await listNews();
      if (res.code === 0) {
        this.news = res.rows.map((item) => ({
          id: item.noticeId,
          date: item.createTime,
          title: item.noticeTitle,
        }));
      }
      this.newsLoading = false;
    },
    goToDetail(item) {
      this.$router.push({ path: `/notice/detail/${item.id}` });
    },
    async getDirectorContactData() {
      this.directorLoading = true;
      this.directorError = false;
      try {
        let res = await getDirectorContact();
        if (res.code === 0 && res.data) {
          this.directorRaw = res.data;
          this.applyDirectorLang();
        } else {
          this.directorError = true;
        }
      } catch (e) {
        this.directorError = true;
      }
      this.directorLoading = false;
    },
    applyDirectorLang() {
      if (!this.directorRaw) return;
      const lang = this.$i18n.locale || "zh";
      const d = this.directorRaw;
      this.director = {
        name: lang === "en" ? d.nameEn : d.nameZh,
        title: lang === "en" ? d.titleEn : d.titleZh,
        email: d.email,
        office: lang === "en" ? d.officeEn : d.officeZh,
        officeHours: lang === "en" ? d.officeHoursEn : d.officeHoursZh,
      };
    },
  },
  watch: {
    "$i18n.locale"() {
      this.applyDirectorLang();
    },
  },
  mounted() {
    this.getNewsList();
    this.getInformList();
    this.getDirectorContactData();
  },
};
</script>

<style scoped>
/* 英雄区域 */
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

/* 主体内容 */
.main-content {
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 20px;
}
.home-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.contact-info {
  flex: 1 1 250px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.contact-title {
  color: #004080;
  font-weight: bold;
  margin-bottom: 15px;
  border-bottom: 2px solid #004080;
  padding-bottom: 10px;
}
.contact-item {
  margin-bottom: 15px;
}
.contact-label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: #004080;
}

.right-content {
  flex: 2 1 500px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.info-box {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.box-title {
  color: #004080;
  font-weight: bold;
  margin-bottom: 15px;
  border-bottom: 2px solid #004080;
  padding-bottom: 10px;
}
.info-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.info-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}
.info-date {
  font-size: 0.8em;
  color: #666;
  margin-right: 15px;
  min-width: 80px;
}
.info-title {
  flex: 1;
  color: #333;
  text-decoration: none;
}
.info-title.clickable {
  cursor: pointer;
}
.info-title.clickable:hover {
  color: #004080;
  text-decoration: underline;
}

/* 骨架屏 */
.skeleton-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}
.skeleton-date {
  width: 80px;
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-right: 15px;
}
.skeleton-title {
  flex: 1;
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 页脚 */
footer {
  background: #003366;
  color: #fff;
  text-align: center;
  padding: 20px;
  margin-top: 50px;
}
.footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.footer-links a {
  color: #fff;
  margin: 5px 10px;
  text-decoration: none;
}
.footer-links a:hover {
  text-decoration: underline;
}

/* 响应式 */
@media (max-width: 992px) {
  .hero-content h1 {
    font-size: 2em;
  }
  .home-container {
    flex-direction: column;
  }
  .contact-info,
  .right-content {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .hero {
    height: 200px;
  }
  .hero-content h1 {
    font-size: 1.5em;
  }
  .main-content {
    padding: 0 10px;
    margin: 20px auto;
  }
  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .info-date {
    margin-bottom: 5px;
  }
}
</style>
